(function (app, ng) {

    app.component("configureOverviewWorkflow", {
        templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Workflows/Overview/overview-template.html",
        controller: workFlowOverviewCtrl,
        bindings: {
            transactionGroup: "<",
            disclosures: "<",
            questionCategories: "<",
            stockQuestions: "<",
            queueWorkflow: "<",
            products: "<"
        }
    });

    workFlowOverviewCtrl.$inject = ["$state", "$mdDialog", "_"];

    function workFlowOverviewCtrl($state, $mdDialog, _) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {}
            });

        this.$onInit = function () {
            $ctrl.overview = [];
            var tmpArray = [];

            if ($ctrl.transactionGroup) {

                if ($ctrl.disclosures.length > 0)
                    tmpArray.push({ Title: "Disclose", Count: $ctrl.disclosures.length });

                if ($ctrl.transactionGroup.CapturePoints.length > 0) {
                    ng.forEach($ctrl.transactionGroup.CapturePoints, function (p) {

                        switch (p) {
                            case 'NeededDocuments':
                                tmpArray.push({ Title: "Capture Documents", Count: $ctrl.transactionGroup.RequiredCaptureDocuments.length });
                                break;
                            case 'Households':
                                tmpArray.push({ Title: "Households", Count: 0 });
                                break;
                            case 'Questionnaire':
                                var tmpQuestions = 0;
                                if ($ctrl.questionCategories.length > 0) {
                                    ng.forEach($ctrl.questionCategories, function (category) {
                                        tmpQuestions += category.QuestionList.length;
                                    });
                                }

                                if ($ctrl.stockQuestions.length > 0) {
                                    tmpQuestions += $ctrl.stockQuestions.length;
                                }

                                tmpArray.push({ Title: "Questions", Count: tmpQuestions });
                                break;
                            case 'Finances':
                                tmpArray.push({ Title: "Finances", Count: 0 });
                                break;
                            case 'Funding':
                                tmpArray.push({ Title: "Funding", Count: 0 });
                                break;
                        }
                    });
                }

                if ($ctrl.transactionGroup.DeterminePoints.length > 0)
                    ng.forEach($ctrl.transactionGroup.DeterminePoints, function (p) {
                        switch (p) {
                            case 'DetermineDocuments':
                                tmpArray.push({ Title: "Determine Documents", Count: $ctrl.transactionGroup.RequiredDetermineDocuments.length });
                                break;
                            case 'Rightbridge':
                                tmpArray.push({ Title: "RightBridge", Count: 0 });
                                break;
                        }

                    });

                if (_.find($ctrl.products, function (p) { return p.Plugins.includes('FireLight') }))
                    tmpArray.push({ Title: "FireLight", Count: 0 });

                if ($ctrl.queueWorkflow)
                    ng.forEach($ctrl.queueWorkflow.Queues, function (q) {
                        tmpArray.push({ Title: q.Name + " Review", Count: 0 });
                    });

                tmpArray.push({ Title: "Carrier Submission", Count: 0 });

                while (tmpArray.length) {
                    $ctrl.overview.push(tmpArray.splice(0, 4));
                }
            }
        };
    }

})(window.app, window.angular);